import React from 'react';
import ShareTab from './ShareTab';
import { Recording } from '~/types/models';
import CenteredModal from '~/App/Modules/Testimonials/Components/CenteredModal';

export type QuickShareModalProps = {
  recording: Recording;
  show: boolean;
  onModalClose: () => void;
};

export default function QuickShareModal({
  recording,
  show,
  onModalClose,
}: QuickShareModalProps) {
  return (
    <CenteredModal
      open={show}
      heading='Share your video'
      onRequestClose={onModalClose}
      width={464}
    >
      <ShareTab recording={recording} redirect />
    </CenteredModal>
  );
}
